// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-promise/auto";
import Vue from "vue";
import vuex from "vuex";
import App from "./App";
import axios from "axios";
import router from "./router";
import element_ui from "element-ui";
import iView from "iview";
import "iview/dist/styles/iview.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import lodash from "@/plugins/lodash";

import "element-ui/lib/theme-chalk/index.css";
import "three-dots/dist/three-dots.css";

import "./assets/css/base.css";
import { login, getwebid } from "@/services/api.js";
import "@/IE.js";
import { Message } from "element-ui";
import customerId_ from "@/constants/customerId.constant"; //引用文件

Vue.config.productionTip = false;
Vue.config.devtools = true;

import store from "./store/index";

Vue.use(lodash, "$lodash");
Vue.use(iView, VueAwesomeSwiper);
Vue.use(element_ui);
Vue.prototype.$axios = axios;
Vue.prototype.CUSTOMERIDARR = customerId_; //挂载到Vue实例上面

var localtoken = localStorage.getItem("token");
var localuser = localStorage.getItem("user");
if (localuser) {
  sessionStorage.setItem("user", localuser);
}
if (localtoken) {
  sessionStorage.setItem("token", localtoken);
}

getwebid({
  domainName: window.location.host
}).then(data => {
  if (data) {
    let webID = data.data;
    axios.interceptors.request.use(
      config => {
        let web_id = webID;
        let uid = webID; //'111111'
        let customer_id = webID;
        const token = sessionStorage.getItem("token");

        const requestUrl = config.url;

        if (token && requestUrl !== "/source/category/getNodesInfo") {
          config.headers.Authorization = "Bearer " + token;
        }

        if (config.data !== "undefined") {
          if (typeof config.data == "string") {
            var data = config.data;
            if (data.indexOf("{") !== -1) {
              data = JSON.parse(data);
              data.web_id = webID;
              data.uid = uid;
              data.customer_id = customer_id;
              config.data = JSON.stringify(data);
            } else {
              let newData = {};
              data = data.split("&");
              data.forEach(item => {
                let newI = item.split("=");
                if (newI.length >= 2) {
                  newData[newI[0]] = newI[1];
                }
              });
              newData.web_id = web_id;
              newData.uid = uid;
              newData.customer_id = customer_id;
              let newStr = "";
              for (let key in newData) {
                newStr += key + "=" + newData[key] + "&";
              }
              config.data = newData;
            }
          } else if (config.data == null) {
            return config;
          } else if (typeof config.data == "object") {
            config.data["web_id"] = web_id;
            config.data["uid"] = uid;
            config.data["customer_id"] = customer_id;
          }
        }
        return config;
      },
      error => {
        return Promise.reject(err);
      }
    );
  }
});
router.beforeEach((to, from, next) => {
  console.log("from", from);
  console.log("to", to);

  window.scrollTo(0, 0);
  var localtoken = localStorage.getItem("token") || to.query.token;

  // console.log('localtoken', localtoken)

  if (localtoken) {
    sessionStorage.setItem("token", localtoken);
  }

  const token = sessionStorage.getItem("token");
  const ifPeople = JSON.parse(sessionStorage.getItem("ifPeople"));

  let peopleHost = false;
  // 判断是否是人民视觉(临时)
  if (
    window.location.host == "people.vcg.com" ||
    window.location.host == "people-v.vcg.com" ||
    window.location.host == "visual.people.cn" ||
    window.location.href == "visual.people.com.cn"
  ) {
    peopleHost = true;
  }

  console.info(
    "-----------fitstPath---ifPeople",
    sessionStorage.getItem("fitstPath", ifPeople, localtoken)
  );
  if (to.path == "/") {
    if (ifPeople || peopleHost) {
      if (localtoken) {
        console.info(
          "-----------fitstPath",
          sessionStorage.getItem("fitstPath")
        );
        next({
          path: "/modelthree"
        });
      } else {
        next({
          path: "/peoplevisual"
        });
      }
    } else {
      next({
        path: sessionStorage.getItem("fitstPath")
      });
    }
  } else {
    var mustlogin = sessionStorage.getItem("mustLogin");
    var ifChangan = JSON.parse(sessionStorage.getItem("ifChangan"));

    if (
      to.matched.some(record => record.meta.requireAuth) ||
      mustlogin == "true"
    ) {
      // 判断该路由是否需要登录权限
      if (
        token ||
        to.path == "/login" ||
        to.path == "/register" ||
        (ifChangan && to.path == "/noLoginModel")
      ) {
        // 判断当前的token是否存在
        next();
      } else {
        //判断是否为视觉长安
        if (ifChangan) {
          next({
            path: "/login"
          });
        } else {
          next({
            path: "/login",
            query: {
              redirect: to.fullPath
            } // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        }
      }

      // 判断该路由是否需要登录权限
      if (
        token ||
        to.path == "/login" ||
        to.path == "/register" ||
        (ifPeople && to.path == "/peoplevisual")
      ) {
        // 判断当前的token是否存在
        next();
      } else {
        //判断是否为视觉长安
        if (ifPeople) {
          next({
            path: "/login"
          });
        } else {
          next({
            path: "/login",
            query: {
              redirect: to.fullPath
            } // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        }
      }
    } else {
      if (ifChangan && !token) {
        if (to.path == "/detail") {
          next({
            path: "/login"
          });
        }
      }

      if (ifPeople && !token) {
        if (to.path == "/detail") {
          next({
            path: "/login"
          });
        }
      }
      next();
    }
  }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js